import { NgModule, Component } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { InnovationcontentListComponent } from './innovationcontent-list/innovationcontent-list.component';
import { InnovationcontentCreateComponent } from './innovationcontent-create/innovationcontent-create.component';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'list-page',
        component: InnovationcontentListComponent,
        data: {
          title: "List Page",
          breadcrumb: "List Page"
        }
      },
      {
        path: 'create-page',
        component: InnovationcontentCreateComponent,
        data: {
          title: "Create Page",
          breadcrumb: "Create Page"
        }
      },
      {
        path: 'innovation-content-create/:id',
        component: InnovationcontentCreateComponent,
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class InnovationContentRoutingModule { }
